import React from "react";

function LoginOtpResendCooldownTimer({ secondsRemaining }) {
  if (secondsRemaining <= 0) {
    return null;
  }

  return <span className={"ml-2 text-black-5"}>({secondsRemaining})</span>;
}

export default LoginOtpResendCooldownTimer;
